import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad0077c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EventsItem__Inner" }
const _hoisted_2 = { class: "EventsItem__Header" }
const _hoisted_3 = { class: "EventsItem__Title" }
const _hoisted_4 = { class: "EventsItem__Content" }
const _hoisted_5 = { class: "EventsItem__Scroller" }
const _hoisted_6 = { class: "EventsItem__Text" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "col2" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "EventsItem__Button__Wrapper" }
const _hoisted_16 = {
  key: 4,
  class: "EventsItem__Button__Warning"
}
const _hoisted_17 = { href: "/faq" }
const _hoisted_18 = {
  key: 5,
  class: "EventsItem__Button__Warning"
}
const _hoisted_19 = { href: "/faq" }
const _hoisted_20 = {
  key: 6,
  class: "EventsItem__Button__Warning"
}
const _hoisted_21 = { href: "/faq" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonClose = _resolveComponent("ButtonClose")!
  const _component_ButtonSave = _resolveComponent("ButtonSave")!
  const _component_EventsRegisterPopin = _resolveComponent("EventsRegisterPopin")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "event",
    onAfterEnter: _ctx.onAfterEnter,
    onAfterLeave: _ctx.onAfterLeave
  }, {
    default: _withCtx(() => [
      (_ctx.event)
        ? (_openBlock(), _createElementBlock("article", {
            class: "EventsItem",
            key: 'event-' + _ctx.event.id
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.event.name), 1),
                _createVNode(_component_ButtonClose, {
                  class: "EventsItem__Close",
                  to: "/events",
                  variant: "dark"
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('events.aboutEvent')), 1),
                    _createElementVNode("p", {
                      innerHTML: _ctx.event.description
                    }, null, 8, _hoisted_7),
                    _hoisted_8,
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('events.when')), 1),
                    _createElementVNode("p", {
                      class: "text-large",
                      innerHTML: _ctx.formatDate(_ctx.event.start_date)
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('events.startTime')), 1),
                        _createElementVNode("p", {
                          class: "text-large",
                          innerHTML: `${_ctx.formatTime(_ctx.event.start_date)} ${_ctx.event.timezone}`
                        }, null, 8, _hoisted_11)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('events.endTime')), 1),
                        _createElementVNode("p", {
                          class: "text-large",
                          innerHTML: `${_ctx.formatTime(_ctx.event.end_date)} ${_ctx.event.timezone}`
                        }, null, 8, _hoisted_12)
                      ])
                    ]),
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('events.where')), 1),
                    _createElementVNode("p", {
                      innerHTML: `${_ctx.event.location}, ${_ctx.event.address}, ${_ctx.event.zip} ${_ctx.event.city}`
                    }, null, 8, _hoisted_13),
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('events.ticketPrice')), 1),
                    _createElementVNode("p", {
                      class: "text-large",
                      innerHTML: `$${_ctx.event.price}`
                    }, null, 8, _hoisted_14)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.event.can_register === 'yes' || _ctx.event.can_register === 'requirement' || _ctx.event.can_register === 'limit' || _ctx.event.can_register === 'done' || _ctx.event.can_register === 'early' || _ctx.event.can_register === 'interested')
                    ? (_openBlock(), _createBlock(_component_ButtonSave, {
                        key: 0,
                        class: "button button--black button--small EventsItem__Button",
                        onClick: _ctx.onGetTicket,
                        saved: _ctx.event.can_register === 'interested',
                        disabled: _ctx.event.can_register === 'limit' || _ctx.event.can_register === 'done' || _ctx.event.can_register === 'requirement' || _ctx.event.can_register === 'early'
                      }, {
                        saved: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.interestedAttendees')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.getTicket')) + " ", 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "saved", "disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.event.can_register === 'registered')
                    ? (_openBlock(), _createBlock(_component_ButtonSave, {
                        key: 1,
                        class: "button button--black button--small EventsItem__Button",
                        saved: _ctx.event.can_register === 'registered'
                      }, {
                        saved: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.booked')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.booked')) + " ", 1)
                        ]),
                        _: 1
                      }, 8, ["saved"]))
                    : _createCommentVNode("", true),
                  (_ctx.event.can_register === 'late')
                    ? (_openBlock(), _createBlock(_component_ButtonSave, {
                        key: 2,
                        class: "button button--black button--small EventsItem__Button",
                        disabled: true
                      }, {
                        saved: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.registrationClosed')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.registrationClosed')) + " ", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.event.can_register === 'full')
                    ? (_openBlock(), _createBlock(_component_ButtonSave, {
                        key: 3,
                        class: "button button--black button--small EventsItem__Button",
                        disabled: ""
                      }, {
                        saved: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.soldOut')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('events.soldOut')) + " ", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.event.can_register === 'requirement')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('events.onlyAvailable')), 1),
                        _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t('events.learnMore')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.event.can_register === 'limit')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('events.alreadyRegisteredEvent')), 1),
                        _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.$t('events.learnMore')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.event.can_register === 'done')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('events.alreadyHaveCertif')), 1),
                        _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t('events.learnMore')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(_component_EventsRegisterPopin, {
              ref: "registerPopin",
              onClose: _ctx.onClose
            }, null, 8, ["onClose"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onAfterEnter", "onAfterLeave"]))
}